module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"管理施設を作成して、検出データを可視化しましょう","description_timeline":"複数センサーの検出傾向を時間帯別に確認できます","create_button":"管理施設を作成"},"en":{"title":"Create a facility to visualize detection data","description_timeline":"View detection trends of multiple sensors by time period","create_button":"Create facility"}}')
  delete Component.options._Ctor
}
